<template>
  <v-main>
    <v-container>
      <v-row justify="start">
        <v-col cols="12">
          <v-card color="#1976d2">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-0">
                  Список отчетов
                </h3>
              </div>
            </v-card-title>
          </v-card>
          <!--<v-flex xs5>-->

          <template>
            <v-card style="margin-bottom:15px;padding-bottom: 15px">
              <v-container fluid grid-list-md class="container-cls">
                <v-row>
                  <v-col class="d-flex"
                         cols="12"
                         sm="4"
                         md="4">
                    <BaseDatePicker :value="lowestDate"
                                    @dateUpdated="dateLowerUpdated"
                                    label="С"
                                    style="padding-top: 23px;" />
                  </v-col>
                  <v-col cols="12"
                         sm="4"
                         md="4">
                    <BaseDatePicker :value="highestDate" @dateUpdated="dateHigherUpdated" label="По" />
                  </v-col>
                  <v-col cols="12"
                         sm="4"
                         md="4">
                    <v-select
                      v-model="filterStageVariable"
                      :items="filterStageOptions"
                      :multiple="false"
                      label="Статус" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12"
                         sm="2"
                         md="2">
                    <v-select
                      v-model="filterProjectVariable"
                      :items="projects"
                      :multiple="true"
                      item-text="name"
                      item-value="id"
                      label="Проект" />
                  </v-col>
                  <v-col cols="12"
                         sm="2"
                         md="2">
                    <v-select
                      v-model="filterVariable"
                      :items="filterOptions"
                      :multiple="false"
                      label="Тип отчета" />
                  </v-col>
                  <v-col cols="12"
                         sm="4"
                         md="4">
                    <BaseAutoComplete
                      v-if="isAdmin"
                      :items="usersListFiltered"
                      :value="selectedUsers"
                      :sel-all="true"
                      :multiple="true"
                      @updateSelected="updateUsers"
                      label="Сотрудники"
                      item-text="full_name"
                      item-value="id" />
                  </v-col>
                  <v-col cols="12"
                         sm="4"
                         md="4">
                    <BaseAutoComplete
                      :items="places"
                      @updateSelected="updatePlaces"
                      label="Места выхода" />
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col class="d-flex"
                         cols="12"
                         sm="3"
                         md="3"
                         style="flex-direction: column;">
                    <v-select
                      v-model="sortValueVariable"
                      :items="sortValueOptions"
                      label="Сортировать по" />
                  </v-col>
                  <v-col cols="12"
                         sm="3"
                         md="3">
                    <v-select
                      v-model="sortVariable"
                      :items="sortOptions"
                      label="Порядок" />
                  </v-col>
                </v-row>
                <v-row />

              <!--              <v-progress-linear v-show="loading" :indeterminate="true" />-->
              </v-container>
            </v-card>
            <v-card v-if="indicatorsForPeriod" v-show="!loading" style="margin-bottom:15px;padding-bottom: 15px">
              <v-card-title>Индикаторы за выбранный период</v-card-title>
              <v-card-text>
                <v-container fluid grid-list-md class="container-cls">
                  <v-row>
                    <v-col v-for="key in Object.keys(indicatorsForPeriod)" :key="key">
                      <b>{{ key }}:</b>
                      <ul>
                        <li v-for="(indicator, name) in indicatorsForPeriod[key]"
                            :key="name">
                          {{ name }}: {{ indicator }}
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </template>
          <v-card v-if="loading">
            <v-skeleton-loader
              type="card-title, article, actions" />
          </v-card>

          <v-card v-for="item in filteredReports"
                  v-show="!loading"
                  :key="item.id"
                  style="margin-bottom:15px;">
            <div :class="reportClasses(item)">
              <v-card-title primary-title class="white--text">
                <v-col cols="12">
                  <h3 class="headline mb-0">
                    <span v-if="duplicatesDict.indexOf(item.id) >- 1">[Дубликат]</span><v-icon v-if="item.stage!=='finished'" color="yellow">
                      mdi-alert
                    </v-icon>{{ reportName(item) }}
                  </h3>
                </v-col>
              </v-card-title>
            </div>
            <v-card-text>
              <v-container fluid grid-list-md class="container-cls">
                <v-row>
                  <v-col class="d-flex"
                         style="flex-direction: column;">
                    <span><b> id: </b>{{ item.id }}</span>
                    <span><b> Дата создания: </b>{{ item.created }}</span>
                    <span v-if="item.created!==item.updated"><b> Дата обновления: </b>{{ item.updated }}</span>
                    <span v-if="item.hours > 0"><b>Часы:</b> {{ item.hours }}</span>
                    <span><b> Клиентов: </b>{{ item.customers ? item.customers : 'нет' }}</span>
                  </v-col>
                  <v-col v-if="item.users && item.users.length > 0"
                         class="d-flex"

                         style="flex-direction: column;">
                    <b>Сотрудники:</b>
                    <ul>
                      <li v-for="(user, idx) in item.users"
                          :key="idx">
                        <span>{{ user.name }} {{ user.surname }}({{ user.email }})</span>
                      </li>
                    </ul>
                    <template v-if="item.volunteers && item.volunteers.length > 0">
                      <b>Волонтеры:</b>
                      <ul>
                        <li v-for="(user, idx) in item.volunteers"
                            :key="idx">
                          {{ user }}
                        </li>
                      </ul>
                    </template>
                  </v-col>
                  <v-col v-if="item.type === 'seminars'"
                         class="d-flex"

                         style="flex-direction: column;">
                    <span><b> Место: </b>{{ item.location }}</span>
                    <span><b> Название: </b>{{ item.name }}</span>
                    <span><b> Спикер: </b>{{ item.speaker }}</span>
                    <span><b> Слушатели: </b>{{ item.audience }}</span>
                    <span><b> Кол-во слушателей: </b>{{ item.attended_num }}</span>
                  </v-col>
                  <!--                  <v-col v-if="item.customers || item.products"-->
                  <!--                         class="d-flex"-->
                  <!--                         style="flex-direction: column;">-->
                  <!--                    <span><b> Клиентов: </b>{{ item.customers ? item.customers : 'нет' }}</span>-->
                  <!--                    &lt;!&ndash;                    <span v-if="item.consultings && Object.keys(item.consultings).length>0">&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      <b>Консультации: </b>&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      <ul>&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                        <li v-for="(amount, name) in item.consultings"&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                            :key="name">&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                          <span>{{ name }}: {{ amount }}</span>&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                        </li>&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                      </ul>&ndash;&gt;-->
                  <!--                    &lt;!&ndash;                    </span>&ndash;&gt;-->
                  <!--                  </v-col>-->
                  <v-col v-if="item.products && Object.keys(item.products).length>0"
                         class="d-flex"
                         style="flex-direction: column;">
                    <span v-if="item.products && Object.keys(item.products).length>0">
                      <b>Материалы: </b>
                      <ul v-if="item.products && Object.keys(item.products).length>0">
                        <li v-for="(amount, name) in item.products"
                            :key="name">
                          <span>{{ name }}: {{ amount }}</span>
                        </li>
                      </ul>
                      <span v-else>
                        нет
                      </span>
                    </span>
                  </v-col>
                  <v-col v-if="item.consultings && Object.keys(item.consultings).length>0"
                         class="d-flex"
                         style="flex-direction: column;">
                    <span v-if="item.consultings && Object.keys(item.consultings).length>0">
                      <b>Консультации: </b>
                      <ul>
                        <li v-for="(amount, name) in item.consultings"
                            :key="name">
                          <span>{{ name }}: {{ amount }}</span>
                        </li>
                      </ul>
                    </span>
                  </v-col>
                  <v-col v-if="item.directions && Object.keys(item.directions).length>0"
                         class="d-flex"
                         style="flex-direction: column;">
                    <span v-if="item.directions && Object.keys(item.directions).length>0">
                      <b>Направления: </b>
                      <ul>
                        <li v-for="(amount, name) in item.directions"
                            :key="name">
                          <span>{{ name }}: {{ amount ? amount : 0 }}</span>
                        </li>
                      </ul>
                    </span>
                  </v-col>
                  <v-col v-if="item.tests && Object.keys(item.tests).length>0"
                         class="d-flex"
                         style="flex-direction: column;">
                    <span v-if="item.tests && Object.keys(item.tests).length>0">
                      <b>Тесты: </b>
                      <ul>
                        <li v-for="(amount, name) in item.tests"
                            :key="name">
                          <span>{{ name }}: {{ amount? amount['total'] : 0 }}</span>
                          <ul>
                            <li>
                              <span>Из них <b>положительных</b>: {{ amount? amount['positive'] : 0 }}</span>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </span>
                  </v-col>
                </v-row>
              </v-container>
              <v-container v-if="item.other"
                           fluid
                           grid-list-md
                           class="container-cls">
                <v-row>
                  <v-col>
                    <span><b> Описание: </b>{{ item.other }}</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-btn @click="edit(item.id, item.type)" text color="blue">
                Отредактировать
              </v-btn>

              <v-btn @click="reportDeleteConfirm(item.id)" text color="blue">
                Удалить
              </v-btn>


              <!--<v-btn text color="blue">Удалить</v-btn>-->
            </v-card-actions>
            <v-divider />
          </v-card>

          <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline">
                Вы собираетесь удалить отчет!
              </v-card-title>
              <v-card-text>
                Вы собираетесь удалить отчет <b>{{ reportDeleteName }}: {{ reportDeleteDate }} </b>, это
                действие необратимо и повлияет на индикаторы, вы
                уверены?
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="dialog = false"
                       color="primary"
                       dark
                       class="mb-2"
                       tile
                       outlined>
                  Отмена
                </v-btn>
                <v-btn @click="reportDelete()"
                       color="green"
                       class="mb-2">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import {authHeader} from '../../_helpers'
import {mapState} from 'vuex'
import BaseAutoComplete from '../base/BaseAutoComplete'
import BaseDatePicker from '../base/BaseDatePicker'

export default {
  name: "ReportsList",
  components: {BaseAutoComplete, BaseDatePicker},
  data () {
    return {
      selectedUsers: [],
      duplicatesDict: null,
      reportDeleteId: null,
      reportDeleteIndex: null,
      reportDeleteDate: null,
      reportDeleteName: null,
      placesSelected: [],
      fixedElementHeight: '174px',
      dialog: false,
      loading: true,
      asyncLoading: true,
      filterVariable: '',
      filterStageVariable: '',
      // filterYearsVariable: 2020,
      lowestDate: this.firstDayOfTheMonth(),
      highestDate: this.lastDayOfTheMonth(),
      sortVariable: 'new',
      sortValueVariable: 'created',
      filterProjectVariable:[],
      filterOptions: [{text: 'Все', value: ''}, {text: 'Аутрич отчеты', value: 'outreaches'}, {
        text: 'Кейс отчеты',
        value: 'casemanagements'
      },
        {
          text: 'Мероприятия',
          value: 'seminars'
        },
        {
          text: 'Психолог',
          value: 'psychologists'
        }, {
          text: 'Юрист',
          value: 'lawyers'
        }, {
          text: 'ЛГБТКИ+',
          value: 'lgbtqcommunities'
        }
      ],
      filterStageOptions:
          [{text: 'Все', value: ''},{text: 'Завершенные', value: 'finished'}, {text: 'Незавершенные', value: 'created'}],
      sortValueOptions: [{text: 'Дате создания', value: 'created'},
        {text: 'Дате выхода', value: 'date'}],
      sortOptions:
          [{text: 'По возрастанию', value: 'old'}, {text: 'По убыванию', value: 'new'}]
    }
  },
  computed: {
    indicatorsForPeriod () {
      let indicators = this.filteredReports.filter(v => v.products && Object.keys(v.products).length>0
          || v.consultings && Object.keys(v.consultings).length>0
          || v.directions && Object.keys(v.directions).length>0
      || v.tests && Object.keys(v.tests).length>0).map(v => ({'Материалы':v.products,'Консультации':v.consultings,'Направления':v.directions,'Тесты':v.tests}))
      let productsPer =  {'Материалы':{},'Консультации':{}, 'Направления':{},'Тесты':{}}
      let types =   ['Материалы','Консультации', 'Направления','Тесты']
      types.forEach( ind => {
        indicators.forEach(function (d) {
          if (d[ind]) {
                let keys = Object.keys(d[ind])
                keys.forEach(key => {
                    if (productsPer[ind].hasOwnProperty(key)) {
                          productsPer[ind][key] = ind==='Тесты' ? productsPer[ind][key] + d[ind][key].total : productsPer[ind][key] + d[ind][key]
                        } else {

                        productsPer[ind][key] = ind==='Тесты' ? d[ind][key].total : d[ind][key]
                        }
                } )
                }
          })
        productsPer[ind] = Object.fromEntries(Object.entries(productsPer[ind]).sort((a,b) => b[1]-a[1]))
        }
      )

      return productsPer
    },
    usersListFiltered () {
      let ul = []
      this.users.forEach(obj => {
        if (obj.user_roles) {
          let roles = obj.user_roles
          roles.forEach(r => {
            if (r.id === 1) {
              obj['full_name'] = obj.name + ' ' + obj.surname
              ul.push(obj)
            }
          })
        }
      })
      return ul
    },
    filteredReports () {
      // let year =  if this.filterYearsVariable!== 0 new Date(this.filterYearsVariable)
      return this.sortedReports.filter(x => ((x.type === this.filterVariable || this.filterVariable === '')
          && (x.stage === this.filterStageVariable || this.filterStageVariable === ''))
          && ((x.project && this.filterProjectVariable.indexOf(x.project.id)>-1) || this.filterProjectVariable.length===0)
          && ((x.place && this.placesSelected.indexOf(x.place.name)>-1) ||  this.placesSelected.length===0)
      )
    },
    sortedReports () {
      let vm = this
      this.loading = true
      this.reports.sort(function (a, b) {
        let dateA = vm.parseDate(a.date)
        let dateB = vm.parseDate(b.date)
        if (vm.sortValueVariable === 'created') {
          dateA = vm.parseDate(a.created.split(' ')[0])
          dateB = vm.parseDate(b.created.split(' ')[0])
        }
        if (dateA < dateB) {
          return vm.sortVariable === 'old' ? -1 : 1
        }
        if (dateA > dateB) {
          return vm.sortVariable === 'old' ? 1 : -1
        }
        return 0
      })
      this.loading = this.asyncLoading
      return this.reports
    },
    ...mapState({
      users: state => state.tableData.users,
      projects: state => state.tableData.projects,
      places: state => state.tableData.places
    }),
  },
  watch: {
    sortVariable (newVal) {
      // this.loading = true
      this.$set(this,'sortVariable',newVal)
    },
    sortValueVariable () {
      this.loading = true
    }
  },
  // mounted () {
  //   this.fixedElementHeight = document.getElementsByClassName('search-fixed')[0].offsetHeight+'px'
  //         // var layout = document.getElementsByClassName('rep-cards')[0]
  //         // layout.style = "padding-top: "+ fixedElement.offsetHeight + 'px'
  // },
  methods: {
     syringesTotal (products) {
      return products.filter(v => v.name.includes('шприц')).reduce((accumulator, syringeType) => {
        return accumulator + parseInt(syringeType.value)
      }, 0)
    },
    reportClasses (item) {
      // let headerClass = item.type==='outreaches' ? 'outreach-header':'case-header'
      return ['header', item.type]
    },
    dateLowerUpdated (newVal) {
      this.lowestDate = newVal
    },
    dateHigherUpdated (newVal) {
      this.highestDate = newVal
    },

    updateUsers (newVal) {
      this.selectedUsers = newVal
    },
    updatePlaces (newVal) {
      this.placesSelected = this.places.filter(v => newVal.some(val => v.id  === val)).map(v => v.name)

    },
    reportName (item) {
      let stage = item.stage === 'finished' ? '' : '(Не завершен)'
      let place = item.place ? item.place.name : 'Без места'
      if (item.type === 'outreaches') return `Аутрич ${place} от ${item.date}${stage}`
      if (item.type === 'casemanagements') return ` Кейс отчет от ${this.getMonth(item.date)}${stage}`
      if (item.type === 'seminars') return ` Мероприятие от ${item.date}${stage}`
      if (item.type === 'psychologists') return `Психолог от ${this.getMonth(item.date)}${stage}`
      if (item.type === 'lawyers') return `Юрист от ${this.getMonth(item.date)}${stage}`
      if (item.type === 'lgbtqcommunities') return `ЛГБТКИ+ от ${item.date}${stage}`
    },
    getReports () {
      let vm = this
      return axios({
        method: 'get',
        url: this.$store.state.tableData.backend + '/api/reports',
        headers: authHeader(),
        params: {
          users: vm.selectedUsers,
          lowestDate: vm.lowestDate,
          highestDate: vm.highestDate
        }
      }).then((response) => {
        // user.authdata =btoa(unescape(encodeURIComponent(this.login + ':' + this.password)));
        vm.loading = false
        vm.asyncLoading = false
        vm.duplicatesDict = response.data.duplicates
        return response.data.reports
        // this.$router.push(this.$route.query.redirect || '/')
      }).catch((error) => {
        vm.loading = false
        throw new Error(`You can't load the data`)
      })
    },
    edit (id, type) {
      // router.push({ path: 'register', query: { plan: 'private' } })
      let route = 'ReportOutreachList'
      switch (type) {
        case "outreaches":
          route = 'ReportOutreachList'
          break
        case "seminars":
          route = 'ReportSeminarsUpdate'
          break
        case "casemanagements":
          route = 'ReportCaseList'
          break
        case "psychologists":
          route = 'ReportPsychList'
          break
        case "lawyers":
          route = 'ReportLawyerList'
          break
        case "lgbtqcommunities":
          route = 'ReportLGBTQUpdate'
          break
        default:
          route = 'ReportOutreachList'
      }
      // let route = type === 'outreaches' ? 'ReportOutreachUpdate' : 'ReportCaseUpdate'
      this.$router.push({name: route, params: {reportId: id}})
    },
    reportDeleteConfirm (id) {
      this.dialog = true
      this.reportDeleteId = id
      this.reportDeleteIndex = this.reports.findIndex(el => el.id === this.reportDeleteId)
      let report = this.reports[this.reportDeleteIndex]
      this.reportDeleteName = report.place.name
      this.reportDeleteDate = report.date

    },
    reportDelete () {
      let vm = this
      this.reports.splice(this.reportDeleteIndex, 1)
      this.duplicatesDict.pop(this.duplicatesDict.indexOf(this.reportDeleteId))
      axios({
        method: 'delete',
        url: this.$store.state.tableData.backend + '/api/reports/' + this.reportDeleteId,
        headers: authHeader()
      }).then((response) => {
        vm.reportDeleteId = null
        vm.dialog = false
        vm.reportDeleteIndex = null
        return response.data
      }).catch((error) => {
        vm.reportDeleteId = null
        vm.dialog = false
        vm.reportDeleteIndex = null
        throw new Error(`You can't load the data`)
      })
    }
  },
  asyncComputed: {
    reports: {
      get () {
        this.loading = true
        this.asyncLoading = true
        let vm = this
        // const requestOptions = {
        //   method: 'GET',
        //   headers: authHeader()
        // }
        return vm.getReports()
      },
      default: []
    }
  }
}
</script>

<style scoped lang="scss">

//.outreach-header {
//  opacity: 0.8;
//  padding: 10px
//}
.header {
  opacity: 0.8;
  padding: 10px;
}
//
//.outreaches {
//  background: #1976d2;
//}
//
//.casemanagements {
//  background: #ffc107;
//}
//
//.seminars {
//  background: #0be7fb;
//
//}
//
//.psychologists {
//  background: #ade498;
//
//}
//
//.lawyers {
//  background: #7fdbda;
//
//}
//
//.lgbtqcommunities {
//  background: #fa448c;
//  //background: linear-gradient(180deg,
//  //    #FE0000 16.66%,
//  //    #FD8C00 16.66%,
//  //    33.32%, #FFE500 33.32%, 49.98%,
//  //    #119F0B 49.98%, 66.64%,
//  //    #0644B3 66.64%, 83.3%,
//  //    #C22EDC 83.3%)
//
//}
//
//.duplicate {
//  background-color: pink;
//}

//.case-header {
//  opacity: 0.8;
//  padding: 10px
//}

.container-cls {
  padding-bottom: 0px;
  padding-top: 0px;
}

.search-fixed {
  position: fixed;
  z-index: 4;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ReportsList.vue